import React from 'react';
import { Breadcrumb } from 'antd';
import { CgChevronLeft } from 'react-icons/cg';
import { Link } from 'react-router-dom';

import { BreadcrumbProps } from '../../../types/componentTypes/BreadcrumbProps';

import './Breadcrumb.scss';

const BreadCrumb = (props: BreadcrumbProps) => {
  const { routeName, navigateTo } = props;

  return (
    <Breadcrumb className="breadcrumb-container">
      <Breadcrumb.Item className="title">
        <Link className="title" to={navigateTo}>
          <CgChevronLeft className="back-button" />
          {`Back to ${routeName}`}
        </Link>
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default BreadCrumb;
